import { isDefined, isNotDefined } from '@sgme/fp';
import { FormGroup } from 'components/missed-deal-feedback/components/form-group';
import { Layout } from 'components/missed-deal-feedback/components/layout';
import { MissedDealFeedbackReadonlyForm } from 'components/missed-deal-feedback/components/readonly-form';
import { SubmissionStatus } from 'components/missed-deal-feedback/components/submission-status';
import { PercentWithUnit } from 'components/shared/Percent/PercentWithUnit';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormattedMessage } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackReset } from 'state/missed-deal-feeedback/actions';
import { getFeedbackAck } from 'state/missed-deal-feeedback/selectors';

export function MissedDealFeedbackSubmitted({ formId }: FormIdProps) {
  return (
    <Layout.Wrapper>
      <Layout.Body>
        <AckWithAdditionalInfo formId={formId} />
        <MissedDealFeedbackReadonlyForm formId={formId} />
        <Ack formId={formId} />
      </Layout.Body>
      <Status formId={formId} />
    </Layout.Wrapper>
  );
}
function Status({ formId: tabId }: FormIdProps) {
  const dispatch = useThunkDispatch();
  return (
    <>
      <SubmissionStatus iconName="check_circle_outline" textIntlKey="missedDealFeedback.feedbackSubmitted">
        <button
          className="btn btn-info"
          data-e2e="missedDealFeedback-ok-button"
          onClick={() => dispatch(missedDealFeedbackReset(tabId))}
        >
          <FormattedMessage id="ok" />
        </button>
      </SubmissionStatus>
    </>
  );
}

function AckWithAdditionalInfo({ formId: tabId }: FormIdProps) {
  const ack = useAppSelector(state => getFeedbackAck(state, tabId));
  if (isNotDefined(ack)) {
    return;
  }

  return (
    isDefined(ack.withAdditionalInformation) && (
      <Layout.Block>
        <div className="d-flex ">
          <FormattedMessage
            tagName="b"
            id={
              !ack.withAdditionalInformation
                ? 'missedDealFeedback.additionalInformationLabel.yes'
                : 'missedDealFeedback.additionalInformationLabel.no'
            }
          />
        </div>
      </Layout.Block>
    )
  );
}

function Ack({ formId: tabId }: FormIdProps) {
  const ack = useAppSelector(state => getFeedbackAck(state, tabId));
  if (isNotDefined(ack)) {
    return;
  }

  return (
    <Layout.Row>
      {isDefined(ack.salesMarginToMatch) && (
        <FormGroup inputId="x-to-match-group" label="missedDealFeedback.xToMatch" className="col-6">
          <PercentWithUnit e2e="x-to-match" unit="%" isReadOnly value={ack.salesMarginToMatch * 100} precision={4} />
        </FormGroup>
      )}
      {isDefined(ack.totalPriceReductionRequired) && (
        <FormGroup
          inputId="total-price-reduction-required-group"
          label="missedDealFeedback.totalPriceReductionRequired"
          className="col-6"
        >
          <PercentWithUnit
            e2e="total-price-reduction-required"
            unit="%"
            isReadOnly
            value={ack.totalPriceReductionRequired * 100}
            precision={4}
          />
        </FormGroup>
      )}
    </Layout.Row>
  );
}
